import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default class TradingViewChart extends React.Component 
  {
    state ={
      chartVisible: false
    }
    render() {

      return (
      <div id="tradingviewchartcontainer" style={{visibility:(this.state.chartVisible)?'visible':'hidden'}} className="tradingview-widget-container" >
          <div id="tradingview_274b1"></div>
          <div className="tradingview-widget-copyright">
            <OutboundLink href="https://www.tradingview.com/symbols/NASDAQ-AAPL/" rel="noreferrer noopener" target="_blank">
                <span className="blue-text">{this.props.ticker} Chart</span></OutboundLink> by TradingView
          </div>
            </div>
      )
    }
    removeChart() {
      const oldChart = document.getElementById("tradingview_274b1")
      oldChart.innerHTML=""
    }
    refreshChart() {
      this.removeChart()
      if (this.props.ticker === "") { //hide component if we don't have a ticker
        this.setState({chartVisible:false}) 
        return;
      } 
      const widgetscript = document.createElement('script')
      this.tvparams.symbol=this.props.ticker
      this.tvparams.width=(this.props.width)?this.props.width:"100%"
      widgetscript.innerHTML = " new TradingView.widget("+JSON.stringify(this.tvparams)+");"
      document.getElementById("tradingviewchartcontainer").appendChild(widgetscript)
      this.setState({chartVisible:true}) 
      
    }
  
  componentDidUpdate(prevProps) {
    if (prevProps.ticker !== this.props.ticker) { //ticker has changed
      this.refreshChart();
    }
  }
  componentDidMount(){
    const script = document.createElement('script')
    script.src = "https://s3.tradingview.com/tv.js"
    document.getElementById("tradingviewchartcontainer").appendChild(script)

    script.onload = () => { //once the tradingview JS has loaded, render the chart (if we've got a ticker)
        this.refreshChart();
    }
  }

  tvparams =   {
     // "width": "100%",
    // "height": 610,
      //"symbol": "AAPL",
      "interval": "D",
      "timezone": "Etc/UTC",
      "theme": "light",
      "style": "1",
      "locale": "en",
      "toolbar_bg": "#f1f3f6",
      "hide_side_toolbar": false,
      "enable_publishing": false,
      "allow_symbol_change": false,
      "container_id": "tradingview_274b1"
  }
  }



